<template>
  <div class="w900" v-if="model">
    <div class="board">
      <div class="boardTitle">
        <div class="boardrd first">
         <span class="title">{{model.title}}</span>
        </div>
        <div class="boardrd">
          <span class="date"><img src="" />{{dateFormatForBoard(model.regDate)}}</span>
        </div>
      </div>
      <div class="boardbox" v-html="model.content">

      </div>
    </div>
    <div class="applibtns">
      <a v-if="prevId" @click="onClickPrevNext('prev')">{{$t('front.board.prev')}}</a>
      <a @click="onClickList">{{$t('front.board.list')}}</a>
      <a v-if="nextId" @click="onClickPrevNext('next')">{{$t('front.board.next')}}</a>
    </div>
  </div>
</template>

<script>

import { getBoardCookie } from '@/libs/auth-helper'

export default {
  name: 'NoticeRead',
  data () {
    return {
      boardType: 'nt',
      boardIdx: null,
      model: null,
      prevId: null,
      nextId: null
    }
  },
  created () {
    this.boardIdx = this.$route.params.boardIdx
    this.loadBoardDetail(this.boardIdx)
    this.idxList = getBoardCookie().split(',')

    if (this.idxList.length > 0) {
      for (let i = 0, iLen = this.idxList.length; i < iLen; i++) {
        if (this.idxList[i] === this.boardIdx.toString()) {
          if (this.idxList[i - 1]) {
            this.prevId = this.idxList[i - 1]
          }
          if (this.idxList[i + 1]) {
            this.nextId = this.idxList[i + 1]
          }
        }
      }
    }
  },
  methods: {
    async loadBoardDetail (boardIdx) {
      const params = {
        boardIdx: boardIdx,
        boardType: this.boardType
      }
      this.model = await this.getBoardDetail(params)
      this.model.content = this.model.content.replace(/\n/g, '<br>')
    },
    onClickPrevNext (type) {
      let id = this.prevId
      if (type === 'next') {
        id = this.nextId
      }
      this.$router.push({ name: 'noticeRead', params: { boardIdx: id } })
    },
    onClickList () {
      this.$router.push({ name: 'noticeList' })
    }
  }
}
</script>
<style scoped src="@/styles/striNew.css"></style>

<style scoped>
.w900 {
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 24px 0 40px !important;
  box-sizing: border-box !important;
}

.board {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.boardTitle {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: #ffffff !important;
  box-sizing: border-box !important;
}

.boardrd {
  min-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  margin: 0 !important;
  padding: 0 20px !important;
  border-bottom: 1px solid #dfe6ef !important;
  background: #ffffff !important;
  color: #475569 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  box-sizing: border-box !important;
}

.boardrd.first {
  min-height: 58px !important;
  border-top: 3px solid #2f6df6 !important;
  background: #f8fafc !important;
}

.boardrd.first .title {
  color: #111827 !important;
  font-size: 16px !important;
  font-weight: 900 !important;
  letter-spacing: -0.2px !important;
}

.boardrd .date {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  color: #475569 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.boardrd .date::before {
  content: '등록일시' !important;
  display: inline-flex !important;
  align-items: center !important;
  height: 23px !important;
  margin-right: 8px !important;
  padding: 0 9px !important;
  border: 1px solid #d4ddeb !important;
  border-radius: 999px !important;
  background: #eef2f7 !important;
  color: #334155 !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  line-height: 23px !important;
}

.boardrd .date img {
  display: none !important;
}

.boardbox {
  min-height: 160px !important;
  padding: 24px 20px 30px !important;
  background: #ffffff !important;
  color: #1f2937 !important;
  font-size: 14px !important;
  line-height: 1.75 !important;
  word-break: break-word !important;
  box-sizing: border-box !important;
}

.boardbox :deep(*) {
  max-width: 100% !important;
}

.boardbox :deep(p) {
  margin: 0 0 10px !important;
  color: #1f2937 !important;
  font-size: 14px !important;
  line-height: 1.75 !important;
}

.boardbox :deep(img) {
  max-width: 100% !important;
  height: auto !important;
}

.applibtns {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  margin: 32px 0 0 !important;
  padding: 0 !important;
}

.applibtns a {
  min-width: 138px !important;
  height: 34px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 18px !important;
  border: 1px solid #5969d7 !important;
  border-radius: 6px !important;
  background: #5969d7 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 800 !important;
  line-height: 34px !important;
  text-decoration: none !important;
  cursor: pointer !important;
  box-shadow: 0 8px 16px rgba(89, 105, 215, 0.16) !important;
  box-sizing: border-box !important;
}

.applibtns a:hover {
  background: #4656c6 !important;
  border-color: #4656c6 !important;
}

@media (max-width: 1000px) {
  .w900 {
    padding: 16px 0 30px !important;
  }

  .board {
    border-radius: 10px !important;
  }

  .boardrd {
    min-height: auto !important;
    flex-wrap: wrap !important;
    padding: 13px 14px !important;
  }

  .boardrd.first {
    min-height: auto !important;
  }

  .boardrd.first .title {
    font-size: 15px !important;
  }

  .boardbox {
    min-height: 120px !important;
    padding: 18px 14px 22px !important;
  }

  .applibtns {
    margin-top: 22px !important;
  }

  .applibtns a {
    min-width: 110px !important;
  }
}
</style>
